import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { invSearchOptions, invSearchOptionsCar, selectDateOrTime, selectDateOrTimeCar } from "../../../../../services/saleAnalysis-services";
import { useTranslation } from "react-i18next";
import { permiCuCo } from "../../../../../Context/InshData";

const useStyles = makeStyles((theme) => ({
    chip: {
        paddingLeft: "10px",
        paddingRight: "10px",
        marginLeft: "10px",
    },
}));

const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

const ItemsDetailsFilter = (props) => {
    const { rptParams, setRptParams, isPurches, isStock, isMake,} = props;
    const type_doc = [
        { id: '02', name: "مبيعات" },
        { id: '01', name: "مشتريات" },
        { id: '11', name: "مرتجع مشتريات" },
        { id: '12', name: "مرتجع مبيعات" },
        { id: '22', name:"مخزون اول مدة" },
        { id: '23', name: "توريد مخزني" },
        { id: '24', name: "صرف مخزني" },
      ];
    const classes = useStyles();
    const { t } = useTranslation(["forms"]);

    return (
        <>
              <Container
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        padding: "10px",
                        margin: "0px",
                    }}
                    component="ul"
                >
                    {type_doc.map((x) => {
                        return (
                            <ListItem key={x.id}>
                                {x.id === rptParams.doc_type ? (
                                    <Chip
                                        className={classes.chip}
                                        label={t(x.name)}
                                        icon={<Done />}
                                        style={{
                                            backgroundColor: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : colors.green[500],
                                            color: "#fff",
                                        }}
                                        clickable
                                    />
                                ) :
                                    (
                                        <Chip
                                            className={classes.chip}
                                            label={t(x.name)}
                                            variant="outlined"
                                            color={isPurches ? "blue" : "green"}
                                            onClick={() => {
                                                setRptParams({ ...rptParams, doc_type: x.id });
                                            }}
                                        />
                                    )}
                            </ListItem>
                        );
                    })}
                </Container>
        </>

    );
};

export default ItemsDetailsFilter;
